// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ContestsOrder, sortContestList } from "@sequentech/ui-core";
var storageKey = function (ballotStyleId) { return "contests-order-".concat(ballotStyleId); };
var bySortOrder = function (contests) {
    return __spreadArray([], contests, true).sort(function (a, b) { var _a, _b, _c, _d; return ((_b = (_a = a.presentation) === null || _a === void 0 ? void 0 : _a.sort_order) !== null && _b !== void 0 ? _b : Infinity) - ((_d = (_c = b.presentation) === null || _c === void 0 ? void 0 : _c.sort_order) !== null && _d !== void 0 ? _d : Infinity); });
};
var storedOrder = function (ballotStyleId, contests) {
    var _a;
    try {
        var ids = JSON.parse((_a = sessionStorage.getItem(storageKey(ballotStyleId))) !== null && _a !== void 0 ? _a : "null");
        if (!Array.isArray(ids) || ids.length !== contests.length) {
            return undefined;
        }
        var byId_1 = new Map(contests.map(function (contest) { return [contest.id, contest]; }));
        var ordered = ids.map(function (id) { return byId_1.get(id); });
        return ordered.every(function (contest) { return contest !== undefined; }) && new Set(ids).size === ids.length
            ? ordered
            : undefined;
    }
    catch (_b) {
        return undefined;
    }
};
/**
 * The contests in the order this voter is shown them, before pagination.
 *
 * A random order is drawn once per ballot and browser session, so the ballot does
 * not reorder while the voter marks it and the review screen can repeat it.
 */
export var orderContestsForVoter = function (ballotStyle) {
    var _a, _b;
    var contests = (_a = ballotStyle.ballot_eml.contests) !== null && _a !== void 0 ? _a : [];
    var order = (_b = ballotStyle.ballot_eml.election_presentation) === null || _b === void 0 ? void 0 : _b.contests_order;
    if (order !== ContestsOrder.RANDOM) {
        return bySortOrder(contests);
    }
    var stored = storedOrder(ballotStyle.id, contests);
    if (stored) {
        return stored;
    }
    var shuffled = sortContestList(contests, order, true);
    sessionStorage.setItem(storageKey(ballotStyle.id), JSON.stringify(shuffled.map(function (contest) { return contest.id; })));
    return shuffled;
};
/** Contests grouped into the ballot's pages, by `pagination_policy`, keeping their order. */
export var paginateContests = function (contests) {
    var _a, _b;
    var pages = new Map();
    for (var _i = 0, contests_1 = contests; _i < contests_1.length; _i++) {
        var contest = contests_1[_i];
        var page = (((_a = contest.presentation) === null || _a === void 0 ? void 0 : _a.pagination_policy) || "").toString();
        pages.set(page, __spreadArray(__spreadArray([], ((_b = pages.get(page)) !== null && _b !== void 0 ? _b : []), true), [contest], false));
    }
    return Array.from(pages.values());
};
/** The contests as the review screen lists them. */
export var orderContestsForReview = function (ballotStyle) {
    var _a;
    var order = (_a = ballotStyle.ballot_eml.election_presentation) === null || _a === void 0 ? void 0 : _a.contests_order;
    return order === ContestsOrder.RANDOM
        ? paginateContests(orderContestsForVoter(ballotStyle)).flat()
        : sortContestList(ballotStyle.ballot_eml.contests, order);
};
